/** @format */

import React, { Component } from 'react';
import { Table, Icon, Progress, Loader, Dimmer } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';
import { getDateFromTimestamp } from '../../helpers/getDateFromTimestamp';
import { getTimestamp } from '../../helpers/getTimestamp';
import renderProgressIcon from '../../helpers/renderProgressIcon';
import RequestsToolbar from './RequestsToolbar/RequestsToolbar';
import AdvanceReqSearch from './AdvanceReqSearch/AdvanceReqSearch';
import './Requests.css';

@inject('RequestsStore', 'VisitedStore', 'UserStore')
@observer
class Requests extends Component {
  componentDidMount = () => {
    this.setState({ visible: true });
  };

  renderTableHeader = () => {
    const { RequestsStore, UserStore } = this.props;
    let renderTableHeader = null;
    const isExternal = UserStore.user.isExternal;
    let tableKeys = isExternal
      ? RequestsStore.requestsParams.tableKeys.map(key => {
          if (key === 'CLIENTE') {
            return 'CODICE';
          }
          return key;
        })
      : RequestsStore.requestsParams.tableKeys;
    renderTableHeader = tableKeys.map((key, index) => {
      return (
        <Table.HeaderCell
          className="table-head-cell"
          onClick={() => RequestsStore.sortRequestsBy(key)}
          key={index + '-' + key}
        >
          {key}
        </Table.HeaderCell>
      );
    });
    return <Table.Row key="">{renderTableHeader}</Table.Row>;
  };

  getRowClass = (value, key) => {
    const { VisitedStore } = this.props;
    const { data } = value;
    let classList = [];

    if (!VisitedStore.visited.includes('/requests/' + key + '/view')) {
      classList.push('hilight');
    }

    if (data.autoManagement) {
      classList.push('auto_management_row');
    }

    return classList.join(' ');
  };

  getRequests = () => {
    const { RequestsStore, UserStore } = this.props;
    const requestsValues = RequestsStore.clientSideFilteredRequests;
    const searchValue = RequestsStore.requestsParams.searchValue;
    const progressFilter = RequestsStore.requestsParams.progressSearch.value;
    RequestsStore.assignKey();
    let sortedRequestsValues = _.orderBy(
      requestsValues,
      ['data.' + RequestsStore.requestsParams.orderBy.prop],
      [RequestsStore.requestsParams.orderBy.direction],
    );

    if (searchValue !== '') {
      sortedRequestsValues.forEach((request, index) => {
        const carName = `${
          RequestsStore.firstRequestPart(request.reqParts).data.carMaker
        } ${RequestsStore.firstRequestPart(request.reqParts).data.carModel}`;

        if (
          (request.data.clientName + ' ' + carName + ' ' + request.data._client)
            .toLowerCase()
            .indexOf(searchValue.toLowerCase()) < 0
        ) {
          delete sortedRequestsValues[index];
        }
      });
    }

    if (progressFilter !== 'tutti i progressi') {
      sortedRequestsValues = sortedRequestsValues.filter(
        item => item.data.progress === progressFilter,
      );
    }

    return sortedRequestsValues
      .filter(
        value =>
          value.data.status === RequestsStore.requestsParams.filter.status,
      )
      .filter(item =>
        item.data.autoManagement ? !UserStore.isWarehouse : true,
      );
  };

  renderTableItem = value => {
    const { RequestsStore, VisitedStore, UserStore } = this.props;
    const hasBeenPrinted = value.data.hasBeenPrinted;
    const key = value.data.key;
    const isExternal = UserStore.user.isExternal;

    if (
      isExternal &&
      !!RequestsStore.hasOptionsAvailableAction(key) &&
      !RequestsStore.hasBeenEditedByExternal(key)
    ) {
      return;
    }
    return (
      <Table.Row
        key={key}
        className={this.getRowClass(value, key)}
        onClick={() => {
          this.props.history.push(`/requests/${key}/view`);
          VisitedStore.addToVisited(`/requests/${key}/view`);
        }}
      >
        <Table.Cell style={{ textAlign: 'center' }}>
          {this.renderStatusIcon(value.data.status)}
          {hasBeenPrinted ? <Icon name="print" /> : null}
        </Table.Cell>
        {!isExternal ? (
          <Table.Cell>
            {value.data.clientName &&
              value.data.clientName
                .toLowerCase()
                .split(' ')
                .map(s => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ')}
          </Table.Cell>
        ) : (
          <Table.Cell>
            {value.data._client && value.data._client.slice(-6)}
          </Table.Cell>
        )}
        <Table.Cell>
          {RequestsStore.firstRequestPart(value.reqParts).data.carMaker}{' '}
          {RequestsStore.firstRequestPart(value.reqParts).data.carModel}
          &nbsp;
          {RequestsStore.hasPhoto(value.reqParts) ? (
            <span style={{ opacity: '0.5' }}>
              <Icon name="image" />
            </span>
          ) : null}
        </Table.Cell>
        <Table.Cell>{value.data.seller}</Table.Cell>
        <Table.Cell>
          {typeof value.data.fromPlace !== 'undefined'
            ? value.data.fromPlace.substring(0, 3).toUpperCase()
            : null}
        </Table.Cell>
        <Table.Cell>
          <Progress
            success={
              value.data.reqPartsNum === value.data.reqPartsChecked &&
              RequestsStore.needDemolitionCheck(value.reqParts)
            }
            size="small"
            value={value.data.reqPartsChecked}
            total={value.data.reqPartsNum}
            progress="ratio"
          />
        </Table.Cell>
        <Table.Cell>
          {this.renderIcon(value.data.progress)}&nbsp;&nbsp;
          {value.data.progress}
          {value.data.progress === 'inoltrata al magazzino'
            ? `(${
                value.data.toPlace
                  ? value.data.toPlace.substring(0, 3).toUpperCase()
                  : ''
              })`
            : null}
          {value.data.progress === 'verifica magazzino'
            ? `(${
                value.data.toPlace
                  ? value.data.toPlace.substring(0, 3).toUpperCase()
                  : ''
              })`
            : null}
        </Table.Cell>
        <Table.Cell>
          {RequestsStore.hasOptionsAvailableAction(key) ? (
            <Icon name="clipboard check" color="green" />
          ) : (
            <Icon name="clipboard check" color="red" />
          )}
        </Table.Cell>
        <Table.Cell>
          {value.data.communicationRecall
            ? getDateFromTimestamp(value.data.communicationRecall, false) + ' '
            : '-'}
          {value.data.communicationRecall ? (
            <Icon
              name="phone"
              color={
                value.data.communicationRecall > getTimestamp()
                  ? 'green'
                  : 'red'
              }
            />
          ) : null}
        </Table.Cell>
        <Table.Cell>{getDateFromTimestamp(value.data.timestamp)}</Table.Cell>
      </Table.Row>
    );
  };

  renderTableBody = () => {
    const { RequestsStore } = this.props;

    const requestsToRender = this.getRequests();

    if (!RequestsStore.requestsParams.requestsLoaded && requestsToRender.length === 0) {
      return (
        <Table.Row>
          <Table.Cell
            colSpan="10"
            className="table-preloader"
            textAlign="center"
          >
            <Dimmer inverted active>
              <Loader size="small" inverted />
            </Dimmer>
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!requestsToRender || requestsToRender.length === 0) {
      return (
        <Table.Row>
          <Table.Cell
            colSpan="10"
            className="table-preloader"
            textAlign="center"
          >
            Nessuna richiesta con questi filtri
          </Table.Cell>
        </Table.Row>
      );
    }

    return requestsToRender.map(this.renderTableItem);
  };

  renderIcon = progress => {
    let icon = null;
    icon = renderProgressIcon(progress);
    return (
      <Icon
        name={icon && icon.name}
        loading={icon && icon.loading}
        color={icon && icon.color}
      />
    );
  };

  renderStatusIcon = status => {
    const icons = {
      attiva: <Icon name="circle thin" size="mini" color="green" />,
      archiviata: <Icon name="circle thin" size="mini" color="red" />,
    };
    return icons[status] || null;
  };

  render() {
    const { RequestsStore } = this.props;
    return (
      <div>
        <RequestsToolbar />
        <AdvanceReqSearch />
        <Table sortable size="small" selectable className="app-manage-table">
          <Table.Header className="table-head">
            {this.renderTableHeader()}
          </Table.Header>
          <Table.Body>
            {this.renderTableBody()}
            <Table.Row
              className="clickable"
              onClick={() => RequestsStore.loadMoreRequests()}
            >
              <Table.Cell colSpan={10} textAlign="center">
                <Icon name="download" />
                <strong>Scarica più richieste</strong>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default withRouter(Requests);
